function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = 'expires=' + d.toUTCString();
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}

function getCookie(cname) {
  let name = cname + '=';
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

function redirectFromCart() {
  setCookie('cartRedirect', 'true', 1);
  window.location.href = '/';
}

function openCartDrawer() {
  const cartRedirect = getCookie('cartRedirect');
  const cartDrawerIcon = document.querySelector('#cart-icon-bubble');
  if (cartRedirect == 'true' && cartDrawerIcon) {
    cartDrawerIcon.click();
    setCookie('cartRedirect', 'false', 1);
  }
}
